import React, { useEffect, useState } from "react"

import {
    Row,
    Col,
    Card,
    CardBody,
    FormGroup,
    Label,
    Input,
    Container,
    FormFeedback,
    Form,
} from "reactstrap"
// Formik validation
import { useFormik } from "formik"

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useHistory, useParams } from "react-router-dom"
import ResultHandler from "../../../components/ResultHandler"
import { editPriceComponent, getPriceComponent } from "../../../api/priceComponent"
import FormButtonHandler from "../../../components/FormButtonHandler"
import useCustomValidation from "../validationSchema"
import { useResponse } from "../../../hooks/useResponse"
import { useTranslation } from "react-i18next"
import { useGetInstence } from "../../../hooks/useGetInstence"
import PriceComponentForm from "./PriceComponentForm"
import FIELDS from "./CONSTANT"
import * as Yup from "yup"

const TYPES = {
    'select': null,
    'add-more': [],
    'checkbox': false,
    'file' : null,
}

const initialValues = {}
const FIELDS_VALIDATION = {}

FIELDS.forEach(f => {
    initialValues[f.key] = TYPES[f.type] ? TYPES[f.type] : "" 
    if(f.type == 'file'){
        FIELDS_VALIDATION[f.key+"_preview"] = Yup.string().required("This Field Is Required")
    }else{
        if (f.key === 'period') {
            FIELDS_VALIDATION[f.key] = Yup.string()
                .when('isPeriodically', {
                    is: true,
                    then: Yup.string().required("This Field Is Required"),
                    otherwise: Yup.string().notRequired()
                });
        } else {
            FIELDS_VALIDATION[f.key] = Yup.string().required("This Field Is Required")
        }
    }
})

FIELDS_VALIDATION['isPeriodically'] = Yup.boolean();


const EditPriceComponent = () => {
    let navigate = useHistory()
    const { priceComponentSchema } = useCustomValidation()

    const { t } = useTranslation()

    const params = useParams()
    const [editedPriceComponent, setEditedPriceComponent] = useState(null)

    const { instenceLoading, instenceError, instenceSuccess } = useGetInstence(
        getPriceComponent,
        params.priceComponentId,
        response => {
            setEditedPriceComponent({
                ...response.data.data.priceComponent,
                period: response.data.data.priceComponent.period == null ? '' : response.data.data.priceComponent.period
            })
        }
    )

    const { setData, loading, error, success } = useResponse(editPriceComponent, () => {
        navigate.goBack()
    })

    // Form validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            ...(editedPriceComponent || {})
        },
        validationSchema: Yup.object(FIELDS_VALIDATION),
        onSubmit: data => {
            setData({ type: "edit", id: params.priceComponentId, data })
        },
    })

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs
                        title={t("PriceComponents")}
                        breadcrumbItem={t("btns.Edit") + " " + t("Price Component")}
                    />
                    
                        {editedPriceComponent && (
                            <Form
                                className="needs-validation"
                                onSubmit={e => {
                                    e.preventDefault()
                                    validation.handleSubmit()
                                    return false
                                }}
                            >
                                <PriceComponentForm validation={validation} />

                                <FormButtonHandler btnTxt="Edit" loading={loading} />
                            </Form>


                        )}

                        <ResultHandler
                            loading={instenceLoading}
                            error={error}
                            success={success}
                            successMsg={"Updated Successfully!"}
                        />
                                
                </Container>
            </div>
        </React.Fragment>
    )
}

export default EditPriceComponent